<ng-container [ngSwitch]="item.values.type">
    <action-sign *ngSwitchCase="'offer'" [action]="item.values"></action-sign>
    <action-sign *ngSwitchCase="'signLease'" [action]="item.values"></action-sign>
    <action-sign *ngSwitchCase="'signAgree'" [action]="item.values"></action-sign>
    <action-sign *ngSwitchCase="'signDeed'" [action]="item.values"></action-sign>
    <action-sign-mandate *ngSwitchCase="'signMandate'" [action]="item.values"></action-sign-mandate>
</ng-container>